<template>
  <b-card no-body>
    <div class="d-flex flex-wrap p-50">
      <div class="col-md-4 p-2 bg-dark rounded">
        <b-img
          :src="require('@/assets/images/fxlegends/icon2-prizeAsset-3.svg')"
          fluid
          class="w-100"
          style="max-height: 170px"
        />
      </div>
      <div class="col p-2">
        <b-card-header class="p-0">
          <h3 class="text-white font-weight-bolder mb-0 ">
            Cheers to you, {{ userData.first_name + " " + userData.last_name }}!
          </h3>
        </b-card-header>
        <b-card-text class="mt-50 h6">
          <p class="mb-0">click the button below</p>
          <p class="mb-0">to see your rewards and achievements</p>
          <b-button  class="mt-50 py-1 gradient-btn flex align-items-center" :to="{name:'Achievments'}">
            <span>view profile</span
            ><span class="ml-2">
              <feather-icon icon="ArrowRightIcon" /> </span
          ></b-button>
        </b-card-text>
      </div>
    </div>
  </b-card>
</template>

<script>
import {
  BCard,
  BCardHeader,
  BCardTitle,
  BCardText,
  BCardBody,
  BButton,
  BImg,
} from "bootstrap-vue";
export default {
  components: {
    BCard,
    BCardHeader,
    BCardTitle,
    BCardText,
    BCardBody,
    BButton,
    BImg,
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("userData")),
    };
  },
};
</script>

<style></style>
